import React, { ReactNode } from 'react';
import { isElement, isString } from './typeCheckExtension';

interface Props {
  value: string | JSX.Element;
  children: string | ReactNode;
}

type BlockType = ReturnType<typeof StringBlock | typeof ElementBlock>;
interface ConditionalProps {
  children: BlockType | Array<BlockType>;
}

const StringBlock = ({ value, children }: Props) => <>{isString(value) && children}</>;

const ElementBlock = ({ value, children }: Props) => <>{isElement(value) && children}</>;

const ConditionBlock = ({ children }: ConditionalProps) => <>{children}</>;

export { ElementBlock, StringBlock, ConditionBlock };
